import React from 'react';
import { useAuth } from '../context/AuthContext';
import { FaUserCircle, FaChartBar, FaShoppingCart, FaUsers } from 'react-icons/fa';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="dashboard-container">
      <div className="mb-4">
        <h2 className="mb-2">Dashboard</h2>
        <p className="text-muted mb-0">Bienvenido, {user?.name}!</p>
      </div>

      <div className="row g-3 g-md-4">
        <div className="col-12 col-md-6 col-lg-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="text-muted small mb-1">Total Usuarios</p>
                  <h3 className="mb-0">-</h3>
                </div>
                <div className="text-primary" style={{ fontSize: '2rem', opacity: 0.7 }}>
                  <FaUsers />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="text-muted small mb-1">Ventas del Mes</p>
                  <h3 className="mb-0">-</h3>
                </div>
                <div className="text-success" style={{ fontSize: '2rem', opacity: 0.7 }}>
                  <FaShoppingCart />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="text-muted small mb-1">Reportes</p>
                  <h3 className="mb-0">-</h3>
                </div>
                <div className="text-info" style={{ fontSize: '2rem', opacity: 0.7 }}>
                  <FaChartBar />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-3">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="text-muted small mb-1">Mi Perfil</p>
                  <h6 className="mb-0 text-capitalize">{user?.role}</h6>
                </div>
                <div className="text-warning" style={{ fontSize: '2rem', opacity: 0.7 }}>
                  <FaUserCircle />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title mb-3">Información del Usuario</h5>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <p className="mb-1"><strong>Nombre:</strong></p>
                  <p className="text-muted">{user?.name}</p>
                </div>
                <div className="col-12 col-md-6">
                  <p className="mb-1"><strong>Email:</strong></p>
                  <p className="text-muted">{user?.email}</p>
                </div>
                <div className="col-12 col-md-6">
                  <p className="mb-1"><strong>Rol:</strong></p>
                  <p className="text-muted text-capitalize">{user?.role}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

